export default "__VITE_ASSET__c9a6afa5__"